import { render, staticRenderFns } from "./PrintDividerPink.vue?vue&type=template&id=9a638566&"
import script from "./PrintDividerPink.vue?vue&type=script&lang=js&"
export * from "./PrintDividerPink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports